import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from '../_services/customer.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  @Output() cancelRegister = new EventEmitter;
  registerForm: FormGroup;
  validationErrors: any[] = [];

  constructor(private customerService: CustomerService, private toastr: ToastrService, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(){
    this.registerForm = this.fb.group({
      companyname: ['', Validators.required],
      contact: ['', Validators.required],
      username: ['', [Validators.required, Validators.email]],
      phonenumber: ['', Validators.required]
    })
  }

  register(){

    this.customerService.register(this.registerForm.value).subscribe(response => {
      this.router.navigateByUrl('/thankyou');
      this.cancel();
    }, error => {
      //console.log(error);
      this.validationErrors = error.error;
      
    });
  }

  cancel(){
    this.cancelRegister.emit(false);
  }

}
